import { saveRecord } from '@/entities/shared/record/save-record';
import type { Task } from '../schemas/task';
import { taskSchema } from '../schemas/task';

export async function saveTask(id: string, data: Partial<Task>): Promise<void> {
  await saveRecord('tasks', taskSchema, id, data);
}
